import { formatPhoneNumberIntl } from "react-phone-number-input";

export const formatInternationalPhoneNumber = (phoneNumber: string): string => {
  return formatPhoneNumberIntl(phoneNumber);
};
